import React, { useState } from "react";
import { Card, CardContent, Typography, IconButton } from "@mui/material";
import ViewIcon from "../../assets/Icon/ViewIcon.png";
import { styled } from "@mui/system";
import CustomDialog from "./CustomDialog";
import { useTranslation } from "react-i18next";
// Styled components
const StyledCard = styled(Card)({
  height: "60px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#E7E7E7",
  border: "1px solid #A5A5A5",
  marginTop: "10px",
});

const StyledCardContent = styled(CardContent)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center", // Align items vertically
  width: "100%",
});

const StyledTypography = styled(Typography)({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "18px",
});

const StyledIconButton = styled(IconButton)({
  display: "flex",
  alignItems: "center",
  marginTop: "18px",
});

const CustomCardView = ({ crop, dialogData }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleViewDetails = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <StyledCard>
        <StyledCardContent>
          <StyledTypography>{t(crop.commodity?.name)}</StyledTypography>
          <StyledIconButton aria-label="view" onClick={handleViewDetails}>
            <img src={ViewIcon} alt="View" />
          </StyledIconButton>
        </StyledCardContent>
      </StyledCard>

      <CustomDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        title={crop.crop_type}
        content={dialogData}
      />
    </>
  );
};

export default CustomCardView;
